import { defineStore } from "pinia";
import IGooglePromotional from "types/GooglePromotional/IGooglePromotional";
import { useMjmlStore } from "./mjmlStore";

type GooglePromotionalKeys = keyof IGooglePromotional;

interface Props {
  prop: GooglePromotionalKeys;
  value: IGooglePromotional[GooglePromotionalKeys];
}

const googlePromotionalDefault: IGooglePromotional = {
  addPromotional: false,
  senderName: "",
  subject: "",
  senderLogo: null,
  showPromoImage: false,
  includeDiscount: false,
  expiration: false,
};

interface State {
  addGooglePromotional?: boolean;
}

export const useGooglePromotionalStore = defineStore("googlePromotional", {
  state: (): State => ({
    addGooglePromotional: false,
  }),

  getters: {
    getPromotionalAttribute:
      () =>
      (prop: GooglePromotionalKeys): any => {
        // const mjmlStore = useMjmlStore();

        // if (mjmlStore.mjml.googlePromotional) {
        //   return mjmlStore.mjml.googlePromotional[prop];
        // } else {
        return googlePromotionalDefault[prop];
        // }
      },
  },

  actions: {
    setGooglePromotional(val: boolean) {
      this.addGooglePromotional = val;
    },

    updatePromotionalAttribute(props: Props) {
      const mjmlStore = useMjmlStore();

      //In a case of using in existing template without googlePromotional existing key
      // if (!mjmlStore.mjml.googlePromotional) {
      //   mjmlStore.mjml.googlePromotional = googlePromotionalDefault;
      // }

      //@ts-expect-error
      mjmlStore.mjml.googlePromotional[props.prop] = props.value;
    },
  },
});
